<template>
  <div>
    <b-form-select
      value-field="id"
      text-field="name"
      @change="onSchemeSelect"
      v-model="schemeId"
      :options="schemes"
    ></b-form-select>

    <div class="row mt-2">
      <div class="col-6">
        <b-form-spinbutton
          v-if="schemeId != null"
          min="2000"
          max="3000"
          @change="onSchemeSelect"
          v-model="year"
        ></b-form-spinbutton>
      </div>
      <div class="col-6">
        <b-form-spinbutton
          v-if="schemeId != null"
          :formatter-fn="monthFormatter"
          wrap
          min="0"
          max="12"
          @change="onSchemeSelect"
          v-model="month"
        ></b-form-spinbutton>
      </div>
    </div>

    <data-table
      v-if="schemeId != null"
      :items="items"
      v-on:updateData="getContributions"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:headings>
        <div class="col-md-3">Contributor</div>
        <div class="col-md-2">Type</div>
        <div class="col-md-2">Amount</div>
        <div class="col-md-3">Processor</div>
        <div class="col-md-1">For</div>
        <div class="col-md-1"></div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-3 my-auto">
          <p class="m-0 font-weight-bold" v-if="slotProps.item.contributor">
            {{ slotProps.item.contributor.first_name }}
            {{ slotProps.item.contributor.surname }} <br />

            <small
              class="m-0 text-muted text-small font-weight-normal"
              v-if="slotProps.item.plan"
            >
              ({{ slotProps.item.plan.name }})
            </small>
          </p>
        </div>

        <div class="col-md-2 my-auto">
          <span
            :class="{
              'text-success': slotProps.item.status == 'Collected',
              'text-danger': slotProps.item.status == 'Not collected',
            }"
          >
            {{ slotProps.item.status }}
          </span>
          <br />
          {{ slotProps.item.payment_type }} <span v-if="slotProps.item.receipt_number != null" class="font-weight-bold">- #{{ slotProps.item.receipt_number }} </span>
        </div>

        <div class="col-md-2 my-auto">
          {{ slotProps.item.amount | currency }}
        </div>
        <div class="col-md-3 my-auto">
          <p class="m-0 font-weight-normal" v-if="slotProps.item.collector">
            {{ slotProps.item.collector.name }}
            <br />
            <span v-if="slotProps.item">
              {{
                moment(new Date(slotProps.item.collected_at)).format(
                  "DD MMM YY"
                )
              }}
            </span>
          </p>
        </div>

        <div class="col-md-1 my-auto">
          <span v-if="slotProps.item.auto_generated == 0"> Ad Hoc </span>

          <span v-if="slotProps.item.auto_generated == 1">
            <span
              v-if="slotProps.item.plan.contribution_frequency == 'Annually'"
            >
              {{ slotProps.item.year }}
            </span>

            <span
              v-if="slotProps.item.plan.contribution_frequency == 'Monthly'"
            >
              {{ months[slotProps.item.month] }} - {{ slotProps.item.year }}
            </span>
          </span>
        </div>

        <div class="col-md-1 my-auto text-right">
          <span
            v-if="userHasPerms(['Reverse contributions'])"
            v-b-tooltip.hover
            style="cursor: pointer"
            title="Reverse Transaction"
            @click="reverseProcessed(slotProps.item)"
            class="text-danger table-action-icon"
          >
            <i class="lni lni-spinner-arrow"></i>
          </span>
          <span
             v-if="slotProps.item.status == 'Collected'"
            v-b-tooltip.hover
            style="cursor: pointer"
            title="Receipt"
            @click="receipt(slotProps.item.collector.id, slotProps.item.id)"
            class="text-success table-action-icon"
          >
            <i class="lni lni-printer m-0"></i>
          </span>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import contributionRepo from "@/api/repos/contributionRepo";
import schemeRepo from "@/api/repos/schemeRepo";
import dataTable from "@/components/common/DataTable";

export default {
  components: {
    dataTable: dataTable,
  },

  data() {
    return {
      organisation_id: localStorage.getItem("current_organisation_id"),
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "created_at", label: "Newest", order: "desc" },
      sortOptions: [
        { column: "created_at", label: "Oldest", order: "asc" },
        { column: "created_at", label: "Newest", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
      paymentTypes: [],
      schemes: [{ id: null, name: "Please select a scheme" }],
      schemeId: null,
      year: new Date().getFullYear(),
      month: 0,
      months: [
        "ALL",
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
    };
  },
  mounted() {
    this.getSchemes();
  },
  methods: {
    monthFormatter(value) {
      return this.months[value];
    },
    async getSchemes() {
      try {
        let { data } = await schemeRepo.schemes(
          1,
          10000,
          "name",
          "asc",
          "",
          null
        );
        data.schemes.data.forEach((x) => this.schemes.push(x));
      } catch (e) {
        console.log(e);
      }
    },

    async getContributions(e) {
      this.isLoad = true;
      try {
        let { data } = await contributionRepo.processed(
          this.schemeId,
          this.year,
          this.month,
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.contributions.data;
        this.totalRows = data.contributions.total;
        this.page = data.contributions.current_page;
        this.fromRow = data.contributions.from;
        this.toRow = data.contributions.to;
        this.lastPage = data.contributions.last_page;

        this.filterOptions = [];

        this.filterOptions.push({
          column: "plan.contribution_frequency",
          value: "Monthly",
          label: "Monthly Plan",
        });

        this.filterOptions.push({
          column: "plan.contribution_frequency",
          value: "Annually",
          label: "Annual Plan",
        });

        this.filterOptions.push({
          column: "plan.contribution_frequency",
          value: "Ad hoc",
          label: "Ad hoc Plan",
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    async reverseProcessed(contribution) {
      let c = "";
      if (contribution.ad_hoc == 0) {
        c =
          "Confirm that you want to move contribution back to outstanding status?";
      } else {
        c = "Confirm that you want to reverse the contribution?";
      }

      this.$bvModal
        .msgBoxConfirm(c, {
          title: "Reverse Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then( async (confirm) => {
          if (confirm) {
            try {
              await contributionRepo.reverseProcessed({
                id: contribution.id,
              });

              this.items = this.items.filter((x) => x.id != contribution.id);

              this.$bvToast.toast("Contribution updated", {
                title: "Updated",
                autoHideDelay: 1000,
                variant: "success",
              });

             
            } catch (e) {
              console.log(e);
              this.$bvToast.toast("Contribution update failed", {
                title: "Failed",
                autoHideDelay: 3000,
                variant: "danger",
              });
            }
          }
        })
        .catch((error) => console.log(error));
    },

    onSchemeSelect() {
      this.schemes = this.schemes.filter((x) => x.id != null);

      this.getContributions({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 10,
        search: "",
      });
    },
    async receipt(contributorId, contributionId) {
      window.open(
        process.env.VUE_APP_API_PATH +
          `prints/receipt/${contributorId}/${contributionId}?cid=${this.organisation_id}`
      );
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
